"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Chip = _interopRequireDefault(require("@material-ui/core/Chip"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _ReactHTMLPicture = _interopRequireDefault(require("@micado-digital/react-htmlpicture/ReactHTMLPicture"));

var _author = _interopRequireDefault(require("./author"));

var _detectButton = _interopRequireDefault(require("./detectButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _makeStyles.default)(function (theme) {
  var _theme$palette, _theme$palette$grey;

  return {
    content: {
      border: "1px solid " + ((_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$grey = _theme$palette.grey) === null || _theme$palette$grey === void 0 ? void 0 : _theme$palette$grey[300]),
      display: "flex",
      flexDirection: "column",
      padding: theme.spacing(3)
    },
    imageRoot: {
      position: "relative",
      "& img, & picture": {
        height: "100%",
        width: "100%"
      }
    },
    imageRootRight: _defineProperty({}, theme.breakpoints.up("sm"), {
      order: 2
    }),
    chip: {
      display: "none",
      position: "absolute",
      right: theme.spacing(2),
      top: theme.spacing(2)
    },
    button: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: "auto",
      paddingTop: theme.spacing(2)
    }
  };
});

var ReactSingleTeaser01 = function ReactSingleTeaser01(_ref) {
  var _clsx;

  var author = _ref.author,
      _ref$buttonColor = _ref.buttonColor,
      buttonColor = _ref$buttonColor === void 0 ? "primary" : _ref$buttonColor,
      _ref$buttonLabel = _ref.buttonLabel,
      buttonLabel = _ref$buttonLabel === void 0 ? "Details" : _ref$buttonLabel,
      _ref$buttonSize = _ref.buttonSize,
      buttonSize = _ref$buttonSize === void 0 ? "medium" : _ref$buttonSize,
      _ref$buttonVariant = _ref.buttonVariant,
      buttonVariant = _ref$buttonVariant === void 0 ? "contained" : _ref$buttonVariant,
      _ref$headlineVariant = _ref.headlineVariant,
      headlineVariant = _ref$headlineVariant === void 0 ? "h4" : _ref$headlineVariant,
      teaser = _ref.teaser,
      media = _ref.media,
      mediaFormats = _ref.mediaFormats,
      mediaPath = _ref.mediaPath,
      variant = _ref.variant,
      icon = _ref.icon,
      iconSize = _ref.iconSize;
  var css = useStyles();

  if (!teaser) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }

  var addition = teaser.addition,
      blogDate = teaser.blogDate,
      link = teaser.link,
      linkTarget = teaser.linkTarget,
      text = teaser.text,
      title = teaser.title;
  var size = variant === 2 || variant === 3 ? "small" : "large";
  var alignment = variant === 1 || variant === 3 ? "right" : "left";
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: "mco-singleteaser-01"
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    className: (0, _clsx2.default)("mco-singleteaser-01__image", (_clsx = {}, _defineProperty(_clsx, css.imageRoot, true), _defineProperty(_clsx, css.imageRootRight, alignment === "right"), _clsx)),
    item: true,
    xs: 12,
    sm: 4,
    md: size === "small" ? 2 : 4
  }, /*#__PURE__*/_react.default.createElement(_ReactHTMLPicture.default, _extends({
    media: media,
    path: mediaPath,
    webpFallback: true
  }, mediaFormats)), blogDate ? /*#__PURE__*/_react.default.createElement(_Chip.default, {
    className: css.chip,
    color: "secondary",
    label: blogDate
  }) : "", author && /*#__PURE__*/_react.default.createElement(_author.default, {
    data: author
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    className: (0, _clsx2.default)("mco-singleteaser-01__content", css.content),
    item: true,
    xs: 12,
    sm: 8,
    md: size === "small" ? 10 : 8
  }, addition && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    gutterBottom: true,
    className: "mco-singleteaser-01__addition",
    color: "textSecondary",
    dangerouslySetInnerHTML: {
      __html: addition
    },
    variant: "overline"
  }), title && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    gutterBottom: true,
    className: "mco-singleteaser-01__title",
    color: "secondary",
    dangerouslySetInnerHTML: {
      __html: title
    },
    component: "h2",
    variant: headlineVariant
  }), text && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: "mco-singleteaser-01__text",
    dangerouslySetInnerHTML: {
      __html: text
    }
  }), link && /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: (0, _clsx2.default)("mco-singleteaser-01__button", css.button)
  }, /*#__PURE__*/_react.default.createElement(_detectButton.default, {
    color: buttonColor,
    label: buttonLabel,
    link: link,
    linkTarget: linkTarget,
    icon: icon,
    iconSize: iconSize,
    size: buttonSize,
    variant: buttonVariant
  })))));
};

ReactSingleTeaser01.propTypes = {
  author: _propTypes.default.object,
  ButtonColor: _propTypes.default.oneOf(["default", "inherit", "primary", "secondary"]),
  buttonLabel: _propTypes.default.string,
  ButtonSize: _propTypes.default.oneOf(["small", "medium", "large"]),
  ButtonVariant: _propTypes.default.oneOf(["text", "contained", "outlined"]),
  headlineVariant: _propTypes.default.oneOf(["h1", "h2", "h3", "h4", "h5", "h6"]),
  teaser: _propTypes.default.object.isRequired,
  media: _propTypes.default.object,
  mediaFormats: _propTypes.default.object,
  mediaPath: _propTypes.default.string,
  variant: _propTypes.default.number,
  icon: _propTypes.default.string,
  iconSize: _propTypes.default.number
};
var _default = ReactSingleTeaser01;
exports.default = _default;